const MuiDialog = (rootElement: HTMLElement) => ({
  defaultProps: {
    container: rootElement,
  },
});

export default MuiDialog;
